import React from "react";
import Header from "../Components/Header/Header";
import GolfLessons from "../Components/GolfLessons/GolfLessons";
import LessonRates from "../Components/LessonRates/LessonRates";
import Footer from "../Components/Footer/Footer";

function Lesson() {


    return (
        <>
            <Header />
            <section id="hero" className="hero img_bg page-section">
                <div className="iframe-hero">
                    <iframe src="https://player.vimeo.com/video/562011685?autoplay=1&controls=0&loop=1&muted=1" title="Embedded Example Website"></iframe>
                </div>
                <div className="container-xl">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="hero_content">
                                <h1 className="hide_mobile">
                                    Our coaches teach <br /> optimal match ups <br /> not swing models.
                                </h1>
                                <h2>
                                    <span className="hide_mobile">Whether you  hyper mobile or lacking mobility, there is a match up for you. We utilize your natural geometry. No cookie cutter lessons around here.</span>
                                </h2>
                                <h1 className="show_mobile">
                                    Find your way, <br /> not just a way.
                                </h1>
                                <h2>
                                    <span className="show_mobile">
                                        We don't subscribe to  “swing models”. Our coaches create optimal match ups by utilizing your natural geometry.
                                    </span>
                                </h2>
                                <div className="arrow_animation show_mobile bounce pt-3">
                                    <i className="bi bi-arrow-down-short" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <GolfLessons />
            <LessonRates />
            <Footer />

        </>
    );
}

export default Lesson;